module.exports = __webpack_public_path__ + "static/img/004.a5a712b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/honor/intellectual_property/004.jpg
// module id = F1/2
// module chunks = 0